import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, change } from 'redux-form';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { SelectField } from '..';
import messages from '../../../text/messages';
import options from '../../../text/selectOptions';

import './../fields.css';

class DurationField extends React.Component {
    componentDidMount() {
        const {
            changeField,
            input: { name, value },
            meta: { form }
        } = this.props;

        if (!value) {
            changeField(form, name, {
                hours: '00',
                minutes: '00'
            });
        }
    }

    render() {
        const {
            input,
            placeholder,
            intl,
            hideErrors,
            meta: { touched, error, warning },
            disabled
        } = this.props;

        let placeholderContent = typeof placeholder === 'string' ? placeholder : intl.formatMessage(placeholder);
        return (
            <div>
                <div className={`duration-field row ${disabled ? 'duration-disabled-field' : ''}`}>
                    <div className="field-placeholder">{placeholderContent}</div>
                    <div className="duration-column">
                        <Field
                            name={`${input.name}.hours`}
                            component={SelectField}
                            options={options.hours24}
                            placeholder={messages.hours}
                            disabled={disabled}
                        />
                    </div>
                    <div className="duration-colon">:</div>
                    <div className="duration-column">
                        <Field
                            name={`${input.name}.minutes`}
                            component={SelectField}
                            options={options.minutes}
                            placeholder={messages.minutes}
                            disabled={disabled}
                        />
                    </div>
                </div>
                {hideErrors === undefined && <span className="validation-message">{touched && (error || warning)}</span>}
            </div>
        );
    }
}

DurationField.defaultProps = {
    placeholder: '',
    meta: {},
    input: {}
};

DurationField.propTypes = {
    placeholder: PropTypes.any,
    meta: PropTypes.object,
    input: PropTypes.object
};

DurationField = injectIntl(DurationField);

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            changeField: change
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DurationField);



// WEBPACK FOOTER //
// ./src/components/fields/duration/index.jsx